goog.provide("shadow.js.shim.module$dayjs$locale$bg");
goog.provide("module$shadow_js_shim_module$dayjs$locale$bg");
shadow.js.shim.module$dayjs$locale$bg = shadow.js.nativeProvides["dayjs/locale/bg"] = require("dayjs/locale/bg");
module$shadow_js_shim_module$dayjs$locale$bg.default = shadow.js.shim.module$dayjs$locale$bg;
